import { render, staticRenderFns } from "./HorizontalSlider.vue?vue&type=template&id=b1fe0a18&scoped=true&"
import script from "./HorizontalSlider.vue?vue&type=script&lang=js&"
export * from "./HorizontalSlider.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalSlider.vue?vue&type=style&index=0&id=b1fe0a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fe0a18",
  null
  
)

export default component.exports